export default __webpack_public_path__ + "static/media/PreList.d0f3a153.svg";